var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1059,
    height: 1011,
    viewBox: "0 0 1059 1011",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip0_137_2434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.017 1204L601.992 761.025L681.5 840.533L318.033 1204H159.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1204V1044.98L681.5 363.483L159.017 -159H318.033L840.517 363.483L0 1204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.98 -159H1363L920.025 283.975L840.517 204.467L1203.98 -159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363 159.033V0.0166626L681.5 681.517L1203.98 1204H1363L840.517 681.517L1363 159.033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363 1044.98L999.533 681.517L1079.04 602.008L1360.16 883.127V1042.14L1363 1044.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -159L522.483 363.483L442.975 442.992L0 0.0166626V-159Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_2434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1363,
    height: 1363,
    fill: "white",
    transform: "translate(0 -159)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.9ae08e1a9617e547dec7e180e2ef414a.svg";
export { ForwardRef as ReactComponent };